<template>
    <!-- 报表管理－加赠品管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'plusGiveTicket')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="用户票券号">
                        <a-input placeholder="请输入" v-decorator="['userTicketId']"></a-input>
                    </a-form-item>
                    <a-form-item label="会员手机号">
                        <a-input placeholder="请输入" v-decorator="['owner']"></a-input>
                    </a-form-item>
                    <a-form-item label="票券名称">
                        <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                    </a-form-item>
                    <a-form-item label="票券状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['state']">
                            <a-select-option value="1">待支付</a-select-option>
                            <a-select-option value="2">支付失败</a-select-option>
                            <a-select-option value="3">已支付</a-select-option>
                            <a-select-option value="4">已过期</a-select-option>
                            <a-select-option value="5">已失效</a-select-option>
                            <a-select-option value="6">退款中</a-select-option>
                            <a-select-option value="7">已退款</a-select-option>
                            <a-select-option value="8">退款失败</a-select-option>
                            <a-select-option value="9">已禁用</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="票券类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['type']">
                            <a-select-option value="1">期限卡</a-select-option>
                            <a-select-option value="2">次卡</a-select-option>
                            <a-select-option value="3">套餐票</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="剩余使用次数">
                        <a-input-group compact >
                            <a-input class="range-input range-input-left" placeholder="剩余最少次数" v-decorator="['minRemindNum']" />
                            <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                            <a-input class="range-input range-input-right" placeholder="剩余最大次数" v-decorator="['maxRemindNum']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="加赠日期">
                        <a-range-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['giveDate']"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>

            <div class="container">
                    
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :scroll="{ x: 800 }" 
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                    style="word-break:break-all"
                >
                    <span slot="ticketType" slot-scope="ticketType">{{['','期限卡','次卡','套餐票','课程','餐券'][ticketType]}}</span>
                    <span slot="state" slot-scope="state">{{['','待支付','支付失败','已支付','已过期','已失效','退款中','已退款','退款失败','已禁用', '已冻结'][state]}}</span>
                    <span slot="information" slot-scope="text,record">剩余使用次数:{{record.total-record.used}};<br>失效时间：{{record.expirationDate}}</span>
                    <span slot="operator" slot-scope="operator">{{operator || "-"}}</span>
                    <span slot="reason" slot-scope="reason" >{{reason || "-"}}</span>
                    <span slot="action" slot-scope="a,item">
                        <a @click="useDetail(item.userTicketId)" v-if="getBtnByAuth('plusGiveTicketUsingDetail')" class="text-primary">使用详情<a-divider type="vertical" /></a>
                        <span v-if="getBtnByAuth('plusGiveTicketForbidden')">
                            <a-popconfirm
                                v-if="Boolean(item.userTicketId) && item.state == 9"
                                title="确定将该票券订单取消禁用吗?"
                                @confirm="disable(item.userTicketId, false)"
                                >
                                    <a class="text-primary">取消禁用</a>
                            </a-popconfirm>
                            <a-popconfirm
                                v-else-if="item.state == 3 || item.state == 8"
                                title="确认禁用吗？"
                                @confirm="disable(item.userTicketId,true)"
                                >
                                <a class="text-primary">禁用</a>

                            </a-popconfirm>
                            <span v-else class="text-disabled">禁用</span>
                        </span>
                    </span>
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex"
    const columns = [
        {
            title: "用户票券号",
            dataIndex: "userTicketId"
        },
        {
            title: "会员手机号",
            dataIndex: "owner"
        },
        {
            title: "票券名称",
            dataIndex: "ticketName"
        },
        {
            title: "票券类型",
            dataIndex: "ticketType",
            scopedSlots: { customRender: "ticketType" }
        },
        {
            title: "票券状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "票券信息",
            dataIndex: "information",
            scopedSlots: { customRender: "information" }
        },
        {
            title: "加赠日期",
            dataIndex: "giveDate"
        },
        {
            title: "加赠操作人",
            dataIndex: "operator",
            scopedSlots: { customRender: "operator" }
        },
        {
            title: "加赠理由",
            dataIndex: "reason",
            scopedSlots: { customRender: "reason" },
            width:'100px'
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    export default {
        name: "coupon",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
                noTitleKey: '1',
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "plusGiveTicket") {
                    this.getList();
                }
            }
        },
        methods: {
            //重置
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            //筛选
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination = page;
                this.getList();
            },
            //获取列表 
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['giveDate'] || [];
                    values.giveStartTime = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD 00:00:00') : undefined;
                    values.giveEndTime = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD 23:59:59') : undefined;
                    delete values.giveDate;
                    this.$api.statement
                        .plusGiveTicket({
                            body:Object.assign(values, {
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize
                            })
                        })
                        .then(res => {
                            this.dataSource = res.data;
                            this.pagination.total = res.total;
                        });
                });
            },
            //查看使用详情
            useDetail(id) {
                this.$router.push({
                    name:"plusGiveTicketUsingDetail",
                    query: { userTicketId: id }
                });
            },
            //更改禁用解禁状态
            disable(id, flag) {
                this.$api.order.forbidden({
                    params: {id: id, flag: flag}
                })
                .then(res => {
                    this.$message.success('操作成功',2)
                    this.getList()
                })
            },
        }, 
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        computed: {
            ...mapGetters(["shopId"])
        },
    };
</script>
<style lang="scss" scoped>
    .container {
        background: #fff;
    }
</style>